import React from 'react';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import ClientListItemEmpty from './ClientListItemEmpty';
import styles from './ClientListItemEmpty.styles';

export default React.memo(compose(withStyles(styles))(ClientListItemEmpty));
